import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineChart = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 7L3.5 4.5L5.5 6L9 2",
		stroke: "currentColor",
		strokeWidth: .83,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLineChart;
